import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string | React.ReactNode;
}

const faqData: FAQItem[] = [
  {
    question: 'Will I lose my customers to your marketing efforts?',
    answer: "Nope! We have a customer database of over 400,000 users, and it's growing every day. By partnering with us, you'll tap into a whole new audience of values-conscious travelers who might not have discovered your parking option otherwise. We're all about adding to your business, not competing with it!"
  },
  {
    question: "We're often nearly full. Would using your service still help us?",
    answer: "If your occupancy averages over 90% for 6+ months a year, that's impressive! For slower times we can help fill those gaps with price-sensitive travelers."
  },
  {
    question: 'Will I lose control of my pricing if I sign on with you?',
    answer: "No, you won't lose control of your pricing. You retain full flexibility to adjust rates based on the time of year and inventory levels. Since our site and marketing are unbranded, you can set lower rates when needed. Our proprietary optimization creates a dual pricing strategy, allowing you to maintain top-tier pricing for most of your inventory."
  },
  {
    question: 'Is there a minimum inventory listing requirement?',
    answer: 'No, Through our partner platform you can easily adjust inventory for sale based on your occupancy and business needs.'
  },
  {
    question: "How's it going in major airports and cities so far?",
    answer: (
      <div>
        <p>We're sending monthly checks to major airports in the following amounts:</p>
        <ul className="mt-2 space-y-1">
          <li>{'>'} <strong>DIA</strong> $40k–$60k</li>
          <li>{'>'} <strong>IAH</strong> $50k–$75k</li>
          <li>{'>'} <strong>PDX</strong> $15k–$25k</li>
          <li>{'>'} <strong>DFW</strong> $11k–$32.5k</li>
        </ul>
      </div>
    )
  },
  {
    question: 'What happens next?',
    answer: "We'd love to connect with you as we expand into new markets through exclusive partnerships. It would be a pleasure to partner with your facility and use our platform to help fill your lots and increase your profits."
  }
];


export default function FAQ() {

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };


  return (
    <div className="w-full bg-gray-50">
      <div className="mx-auto px-4 md:px-32 xl:px-4 space-y-6 max-w-7xl py-16">
        <h2 className="text-xl lg:text-3xl font-bold text-center">
          FAQ
        </h2>
        <div className="border rounded-md divide-y bg-white">
          {faqData.map((item, index) => (
            <div key={index} className="overflow-hidden p-4">
              <button
                type='button'
                onClick={() => toggle(index)}
                className="w-full flex justify-between items-center font-semibold text-left"
              >
                <span className="text-base">{item.question}</span>
              </button>
              {openIndex === index && (
                <div className="p-2 text-base text-gray-700 ">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
